(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentDialogController', FreightPaymentDialogController);

    FreightPaymentDialogController.$inject = ['$scope','$timeout','$stateParams','$uibModalInstance','entity','FreightPayment','FreightPaymentCustomService','ToastrService','DateUtils'];

    function FreightPaymentDialogController($scope, $timeout, $stateParams, $uibModalInstance, entity, FreightPayment, FreightPaymentCustomService, ToastrService, DateUtils) {
        var vm = this;

        vm.fp = entity;
        vm.currencyTypes = ['USD','EUR'];

        vm.clear = clear;
        vm.save = save;
        vm.updateInvoiceAmountDisplay = updateInvoiceAmountDisplay;
        vm.onTextClick = onTextClick;
        vm.activateCurrencyType = activateCurrencyType;
        vm.openCalendar = openCalendar;
        vm.checkDuplicate = checkDuplicate;
        vm.duplicateMsg = null;
        vm.duplicates = [];

        if(vm.fp.id === null) updateInvoiceAmountDisplay();

        vm.datePickerOpenStatus = {
            paymentDate: false
        };

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if(vm.fp.id !== null) {
                FreightPayment.update(vm.fp, onSaveSuccess, onSaveError);
            } else {
                FreightPayment.save(vm.fp, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('ccsTrApp:freightPaymentUpdate', result);
            ToastrService.success("Successfully saved Freight Payment", "Success!");
            $uibModalInstance.close(result);
            resolveDates();
            vm.isSaving = false;
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error");
            resolveDates();
            vm.isSaving = false;
        }

        function updateInvoiceAmountDisplay() {
            vm.fp.invoiceAmountDisplay = vm.fp.invoiceCurrency + " " + vm.fp.invoiceAmount;
        }

        function activateCurrencyType(type) {
            vm.fp.invoiceCurrency = type;
            updateInvoiceAmountDisplay();
        }

        function onTextClick($event) {
            $event.target.select();
        }

        function resolveDates() {
            if(vm.fp.paymentDate !== null) {
                vm.fp.paymentDate = DateUtils.convertLocalDateFromServer(vm.fp.paymentDate);
            }
        }

        function checkDuplicate() {
            vm.duplicates = [];
            vm.duplicateMsg = null;
            FreightPaymentCustomService.returnFreightPaymentsByBlNumber(vm.fp.blNumber).then(function(data) {
                vm.duplicates = data.data;
                if(vm.fp.id !== null) {
                    var index = vm.duplicates.findIndex(function(obj){ return obj.id == vm.fp.id});
                    vm.duplicates.splice(index, 1);
                }
                vm.duplicateMsg = "Found " + vm.duplicates.length + " Freight Payments with the same BL Number";
            }, function(error) {
                ToastrService.error("Failed to check for duplicate BL Numbers", "Error");
            });
        }
    }
})();
